// extracted by mini-css-extract-plugin
export default {"skeletonBlock":"ProjectSkeleton_skeletonBlock__sMiP5","skeleton":"ProjectSkeleton_skeleton__DdGGL"};